/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetToolUsageFilterOptionsPayload,
  GetToolUsageFilterOptionsPayload$Outbound,
  GetToolUsageFilterOptionsPayload$outboundSchema,
} from "../components/gettoolusagefilteroptionspayload.js";

export type GetToolUsageFilterOptionsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolUsageFilterOptionsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolUsageFilterOptionsSecurity = {
  option1?: GetToolUsageFilterOptionsSecurityOption1 | undefined;
  option2?: GetToolUsageFilterOptionsSecurityOption2 | undefined;
};

export type GetToolUsageFilterOptionsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getToolUsageFilterOptionsPayload: GetToolUsageFilterOptionsPayload;
};

/** @internal */
export type GetToolUsageFilterOptionsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolUsageFilterOptionsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    GetToolUsageFilterOptionsSecurityOption1$Outbound,
    GetToolUsageFilterOptionsSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function getToolUsageFilterOptionsSecurityOption1ToJSON(
  getToolUsageFilterOptionsSecurityOption1:
    GetToolUsageFilterOptionsSecurityOption1,
): string {
  return JSON.stringify(
    GetToolUsageFilterOptionsSecurityOption1$outboundSchema.parse(
      getToolUsageFilterOptionsSecurityOption1,
    ),
  );
}

/** @internal */
export type GetToolUsageFilterOptionsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolUsageFilterOptionsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    GetToolUsageFilterOptionsSecurityOption2$Outbound,
    GetToolUsageFilterOptionsSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function getToolUsageFilterOptionsSecurityOption2ToJSON(
  getToolUsageFilterOptionsSecurityOption2:
    GetToolUsageFilterOptionsSecurityOption2,
): string {
  return JSON.stringify(
    GetToolUsageFilterOptionsSecurityOption2$outboundSchema.parse(
      getToolUsageFilterOptionsSecurityOption2,
    ),
  );
}

/** @internal */
export type GetToolUsageFilterOptionsSecurity$Outbound = {
  Option1?: GetToolUsageFilterOptionsSecurityOption1$Outbound | undefined;
  Option2?: GetToolUsageFilterOptionsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolUsageFilterOptionsSecurity$outboundSchema: z.ZodMiniType<
  GetToolUsageFilterOptionsSecurity$Outbound,
  GetToolUsageFilterOptionsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetToolUsageFilterOptionsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetToolUsageFilterOptionsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getToolUsageFilterOptionsSecurityToJSON(
  getToolUsageFilterOptionsSecurity: GetToolUsageFilterOptionsSecurity,
): string {
  return JSON.stringify(
    GetToolUsageFilterOptionsSecurity$outboundSchema.parse(
      getToolUsageFilterOptionsSecurity,
    ),
  );
}

/** @internal */
export type GetToolUsageFilterOptionsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetToolUsageFilterOptionsPayload: GetToolUsageFilterOptionsPayload$Outbound;
};

/** @internal */
export const GetToolUsageFilterOptionsRequest$outboundSchema: z.ZodMiniType<
  GetToolUsageFilterOptionsRequest$Outbound,
  GetToolUsageFilterOptionsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getToolUsageFilterOptionsPayload:
      GetToolUsageFilterOptionsPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getToolUsageFilterOptionsPayload: "GetToolUsageFilterOptionsPayload",
    });
  }),
);

export function getToolUsageFilterOptionsRequestToJSON(
  getToolUsageFilterOptionsRequest: GetToolUsageFilterOptionsRequest,
): string {
  return JSON.stringify(
    GetToolUsageFilterOptionsRequest$outboundSchema.parse(
      getToolUsageFilterOptionsRequest,
    ),
  );
}
